<script setup lang="ts">
import { type ConfirmModalAction, UiModal } from '../index';
import { UiButton } from '../../button';
import { UiStyles } from '../../../styles/Styles';

withDefaults(defineProps<{
  title?: string,
  message?: string,
  postfixAttention?: string,
  actions?: ConfirmModalAction[],
}>(), {
  title: '',
  message: '',
  postfixAttention: '',
  actions: () => [
    { locale: 'global.buttons.cancel', action: 'cancel' },
    { locale: 'global.buttons.apply', action: 'apply', theme: UiStyles.UiTheme.Primary },
  ],
});

const show = defineModel<boolean>({ default: false });

const emit = defineEmits([]);

function onClick(name: string) {
  emit('click:' + name);
  emit(name);
  show.value = false;
}
</script>

<template lang="pug">
UiModal.ui-modal-confirm(
  v-model="show"
  :heading="title"
  :full="false"
  :size="UiStyles.UiSize.Small"
  :footerLine="!!message"
)
  template(v-slot)
    .text {{ $t(message) }}
      span.postfix-attention(v-if="postfixAttention")  {{ $t(postfixAttention) }}
      slot
  template(v-slot:footer)
    .modal-actions.flex.row-12
      UiButton.button(
        v-for="action of actions"
        :key="action.locale"
        :class="{_attention: action.attention}"
        :locale="action.locale"
        :theme="action.theme || UiStyles.UiTheme.Secondary"
        @click="onClick(action.action)"
      )
</template>

<style lang="scss" scoped>
@import '../../../styles/colors';

.ui-modal-confirm {
  :deep(.ui-background-abstract) {
    z-index: 1060;
  }
}

.modal-actions {
  justify-content: end;
}

.text {
  white-space: pre-wrap;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: $ui-color-text-secondary;
}

.button._attention {
  color: $ui-color-text-error;
}

.postfix-attention {
  color: $ui-color-text-error;
}
</style>
